<div  *ngIf="this.userInfo!== null && this.userInfo.internalUser && this.model" class="wrapper">
    <div class="row">
        <div class="col-md-10">
            <ol class="breadcrumb">
                <li>
                    <a [routerLink]="['/admin/announcements']">Announcements</a>
                    / {{!edited ? 'Detail' : name}}
                </li>
            </ol>
        </div>
        <div class="col-md-4">
        </div>
    </div>
    <div *ngIf="!edited && model" class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2 announcement-edit">
            <button [disabled]="!enabled" type="button" class="btn btn-primary col-md-12" (click)="onEdit()">Edit</button>
        </div>
        <div class="col-md-2">
            <div><span class="red">* </span>Required Fields</div>
        </div>
    </div>
    <div *ngIf="edited" class="row">
        <div class="col-md-8">
        </div>
        <div class="col-md-2">
            <button type="button" class="btn btn-default col-md-12" (click)="onCancel()">Cancel</button>
        </div>
        <div class="col-md-2">
            <button type="button" class="btn btn-primary col-md-12" (click)="onSubmit()" [disabled]="!announcement.Form.valid">Submit</button>
        </div>
        <div class="col-md-2">
            <div><span class="red">* </span>Required Fields</div>
        </div>
    </div>
    <announcement #announcement [(announcement)]="model" [edited]="edited" [disabled]="!edited" ></announcement>
</div>
<modal-component #cancelUpdateAnnouncement
                 (reject)="cancelEditAnnouncement()"
                 [title]="cancelTitle"
                 [data]="{
        resizeOrClose:'close',
        okBtnTitle:'Cancel',
        okBtnCssClass:'btn btn-primary',
        small:true,
        cancelBtnTitle: 'Continue',
        resubmitBtnTitle: '',
        cancelBtnCssClass:'btn btn-primary'}">
    <div class="hml-source">{{sourceModalContent}}</div>
</modal-component>

